export const STG_API_GATEWAY_URL = 'https://vendor-api03.stg.restaurant-partners.com/';
